module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAMAAAAoLQ9TAAAAM1BMVEX29vZMm/K92PWFufPj6/Xv8vbZ5vXP4fSgyPNlqPJTnvLg6vXE2/SqzfSPv/N7tPNyr/M51O3YAAAAUElEQVQY06WNWwqAMAwEd9OmtfV5/9MqsUgM+OX8LAxMAqydxq646bONHssQHJvkEVqQsxdlgoiJryQLakXixeaFAMqYMB5lfOuSP6LxRTsB5CQBZaOs3WIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/mine/酒店名称.png
// module id = 1364
// module chunks = 5